<div class="tab-wrapper mb-5">
  <table class="table table-connectpay">
    <thead>
      <tr>
        <th>Date Requested</th>
        <th>Request Type</th>
        <th>Decided By</th>
        <th>Decision</th>
        <th>Request Details</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let request of requests">
        <td>{{ request.DateRequested | date: 'MM/dd/YY' }}</td>
        <td>{{ request.RequestType }}</td>
        <td>{{ request.CompletedBy }}</td>
        <td>
          <span *ngIf="request.Pending" class="fst-italic">Pending</span>
          <span class="text-cp-green" *ngIf="request.Approved && !request.Pending">Approved</span>
          <span class="text-danger" *ngIf="!request.Approved && !request.Pending">Declined</span>
        </td>
        <td>
          <button class="btn btn-tertiary request-button" (click)="viewRequest(request)">
            Review Change
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<lib-address-change-review-modal
  *ngIf="addressRequestData != null"
  [changeRequest]="selectedRequest"
  [addressChangeRequestData]="addressRequestData"
  (modalClosed)="closeModal($event)"></lib-address-change-review-modal>
<lib-direct-deposit-change-review-modal
  *ngIf="directDepositRequestData != null"
  [changeRequest]="selectedRequest"
  [changeRequestData]="directDepositRequestData"
  (modalClosed)="closeModal()"
  [readonly]="true"></lib-direct-deposit-change-review-modal>
